import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { Container } from 'app/models/container.model';
import { DeviceLatestStatus } from 'app/models/device-latest-status.model';
import { Device } from 'app/models/device.model';
import { User } from 'app/models/user.model';
import { ContainerService } from 'app/services/container.service';
import { DeviceRequestService } from 'app/services/device-request.service';
import { DeviceService } from 'app/services/device.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericMapComponent } from '../../generic-map/generic-map.component';
import { DeviceEditComponent } from '../device-edit/device-edit.component';
import { DeviceFirmwareUpdateComponent } from '../device-firmware-update/device-firmware-update.component';
import { DeviceCompanyUpdateComponent } from '../device-company-update/device-company-update.component';

@Component({
    selector: 'device-list',
    templateUrl: './device-list.component.html',
    styleUrls: ['./device-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DeviceListComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    public selection = new SelectionModel<Device>(true, []);

    widgets: any;
    public user: User
    public companyId = parseInt(localStorage.getItem("CompanyID"))
    public requestLoading = false;
    private _duration: string;
    public roleId = localStorage.getItem('RoleID');

    highlightedRows = [];
    highlightedRowss = {};

    public selected = {
        solar: "",
        battary: "",
        heat: "",
        mesafe: "",
    }

    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }

    public get duration(): string {
        return this._duration;
    }

    private _devicesList: Array<Device> = [];

    public get devicesList(): Array<Device> {
        return this._devicesList;
    }
    private _requestList: Array<DeviceLatestStatus> = [];

    public get requestList(): Array<DeviceLatestStatus> {
        return this._requestList;
    }

    private _dataSource: MatTableDataSource<Device> = undefined;
    public get dataSource(): MatTableDataSource<Device> {
        return this._dataSource;
    }

    private _displayedColumns = ['select','id', 'model', 'firmware','runType','firmwareUpdateCheck', 'updated', 'deviceLatestStatus.sonBaglantiTarih', 'udate','companyId', "setting"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _deviceService: DeviceService,
        private _spinner: NgxSpinnerService,
        private _dialog: MatDialog,
        private _toastService: ToasterService,
        private _containerService: ContainerService,
        private _translateService: TranslateService
    ) {
    }


    public async ngOnInit() {
        await this.getDeviceList();
    }

    private async getDeviceList(): Promise<Array<Device>> {
        try {
            this._spinner.show('loading');
            this._devicesList = await this._deviceService.getDevices(parseInt(localStorage.getItem("CompanyID")));
            
            if(this.devicesList.length!=0){
                this.requestChange(this.devicesList[0])
            }
            
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }
    
     public async requestChange(device: Device) {
         this.requestLoading = true;
         var container = await this._containerService.getByDeviceContainer(device.id);

         if (!device.deviceLatestStatus) {
             this.selected.battary = "";
             this.selected.heat = "";
             this.selected.solar = "";
             this.selected.mesafe = "";
             this._toastService.toastWarning(this._translateService.instant("DEVICE_DATA_CLOUD_NOT_BE_RETRIEVED"))
             return;
         }

         this.selected.battary = device.deviceLatestStatus?.batarya
         this.selected.heat = device.deviceLatestStatus?.cpuSicaklik
         this.selected.solar = device.deviceLatestStatus?.solarEnerjiVoltaj
         var calc=0;

         if(container){
            calc=((((parseInt(container.altitude) - parseInt(container.deadZone)) - (parseInt(device.deviceLatestStatus?.mesafe) - parseInt(container.deadZone))) * 100)
             / (parseInt(container.altitude) - parseInt(container.deadZone)));
                     if(calc<0){
                         calc=0;
                     }else if(calc>100){
                         calc=100;
                     }
             this.selected.mesafe = device.deviceLatestStatus.mesafe?calc.toFixed(2):'---'
         }else{
            this.selected.mesafe = "-1"  
         }

         this.highlightedRowss = []
         this.highlightedRows.push(device);
         this.highlightedRowss[device.id] = !this.highlightedRowss[device.id];
         this.requestLoading = false

     }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Device>(this._devicesList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
        this.dataSource.sortingDataAccessor = (item, property) => {      
            switch (property) {
              case 'deviceLatestStatus.sonBaglantiTarih':
                if(item.deviceLatestStatus?.sonBaglantiTarih)
                    return new Date(item.deviceLatestStatus.sonBaglantiTarih);
              default:
                return item[property];
            }
          };
    }

    public addDevices() {
        const dialog = this._dialog.open(DeviceEditComponent, {
            data: new Device(),
            disableClose: false,
        });

        dialog.componentInstance.operation = "create"

        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    
    public updateDevices(device) {
        const dialog = this._dialog.open(DeviceEditComponent, {
            data: cloneDeep(device),
            disableClose: false
        });

        dialog.componentInstance.operation = "update"
        dialog.componentInstance.model = cloneDeep(device)

        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    public updateCompanyDevices(device) {
        const dialog = this._dialog.open(DeviceCompanyUpdateComponent, {
            data: cloneDeep(device),
            disableClose: false
        });

        dialog.componentInstance.operation = "update"
        dialog.componentInstance.model = cloneDeep(device)

        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }

    public async changeFirmwareUpdateCheck(device) {
 
        try {
            const dialog = this._dialog.open(DeviceFirmwareUpdateComponent,{
            })


            dialog.componentInstance.devices = []
            dialog.componentInstance.devices = [cloneDeep(device)]
            dialog.componentInstance.updated.subscribe(async(x)=>{       
                x?this._toastService.toastSuccess():this._toastService.toastFail();              
                dialog.close();
            })

        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }
    }

    public async allChangeFirmwareUpdateCheck() {
        try {
            const dialog = this._dialog.open(DeviceFirmwareUpdateComponent,{

            })
            dialog.componentInstance.devices = []
            dialog.componentInstance.devices = this.selection.selected
            dialog.componentInstance.updated.subscribe(async(x)=>{    
                x?this._toastService.toastSuccess():this._toastService.toastFail();                 
                dialog.close();
            })
            
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }
    }


    public async deleteDevices(device: Device) {
        var container: Array<Container>;
        try {
            container = await this._containerService.getContainers(parseInt(localStorage.getItem("CompanyID")));
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return;
        }
        var containerFilter = container.filter(x => x.deviceId == device.id);
        if (containerFilter.length != 0) {
            this._toastService.toastFail(this._translateService.instant("THE_DELETION_WAS_UNSUCCESSFUL_THERE_IS_A_CONTAINER_TO_WHICH_IT_IS_ATTACHED"))
            return;
        }
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen cihazı silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                await this._deviceService.delete(device);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);

        }
        this.refresh();
    }


    public async onDevicesMap(element: Device) {
        const dialog = this._dialog.open(GenericMapComponent, {
        })
        dialog.componentInstance.latitude = parseFloat(element.deviceLatestStatus?.gpS_Enlem)
        dialog.componentInstance.longitude = parseFloat(element.deviceLatestStatus?.gpS_Boylam);
    }

    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource?.data.length;
        return numSelected === numRows;
      }
    
      /** Selects all rows if they are not all selected; otherwise clear selection. */
      masterToggle() {
        this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
      }
    
      /** The label for the checkbox on the passed row */
    
      checkboxLabel(row?: Device): string {
        if (!row) {
          return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row!) ? 'deselect' : 'select'} row ${+1}`;
      }

    refresh() {
        this.getDeviceList();
    }
}
